import React, { useState, useEffect, Fragment } from 'react';
import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';
import API from '../../services/API';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import Select from 'react-select';
import { useNavigate } from "react-router-dom";

const CustomAttendanceTypePage = () => {
    const [attendanceTypes, setAttendanceTypes] = useState([]);
    const [isTypeModalOpen, setIsTypeModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

    const [selectedType, setSelectedType] = useState(null);
    const [formTypeName, setFormTypeName] = useState('');
    const [formTypeDesc, setFormTypeDesc] = useState('');
    const [formTypeActive, setFormTypeActive] = useState(1);

    const [selectedDeleteType, setSelectedDeleteType] = useState(null);
    const [formRequiresNotif, setFormRequiresNotif] = useState(0);
    const [formNotifTime, setFormNotifTime] = useState(0);
    const [teachers, setTeachers] = useState([]);
    const [selectedTeachers, setSelectedTeachers] = useState([]);

    const navigate = useNavigate();

    const handleView = (row) => {
        navigate(`/customAttendanceDetail?id=${row.type_id}`);
    };
    // Columns
    const [columns] = useState([
        { name: "Name", selector: row => row.name, sortable: true },
        { name: "Description", selector: row => row.description || "-", wrap: true },
        {
            name: "Active",
            selector: row => row.is_active === 1 ? "Yes" : "No",
            sortable: true,
            center: true
        },
       {
  name: "Actions",
  cell: (row) => (
    <div className="d-flex gap-2">
      <button
        className="btn btn-sm btn-info"
        onClick={() => handleView(row)}
      >
        View
      </button>
   
      <button
        className="btn btn-sm btn-warning"
        onClick={() => openEditTypeModal(row)}
      >
        Edit
      </button>
      <button
        className="btn btn-sm btn-danger"
        onClick={() => openDeleteModal(row)}
      >
        Delete
      </button>
    </div>
  ),
  center: true,
}
    ]);
    // Fetch all teachers from the API
    const fetchTeachers = () => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        API.get('/portal/getTeachers', { headers })
            .then((response) => {
                if (response.data.response_code === 1000) {

                    const teacherOptions = response.data.data.map((teacher) => ({
                        label: teacher.full_name,
                        value: teacher.teacher_uuid,
                    }));

                    setTeachers(teacherOptions);
                } else {
                    toast.error(`${response.data.message}`, { autoClose: 5000 });
                }
            })
            .catch(() => {
                toast.error("Error fetching teachers", { autoClose: 5000 });
            });
    };

    // Fetch Attendance Types
    const fetchAttendanceTypes = () => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };
        API.get('/customAttendance/type?is_portal=true', { headers })
            .then((res) => {
                if (res.data.response_code === 1000) {
                    console.log(res)
                    setAttendanceTypes(res.data.data || []);
                } else {
                    toast.error(res.data.message);
                }
            })
            .catch(() => toast.error("Error fetching attendance types"));
    };

    useEffect(() => {
        fetchAttendanceTypes();
    }, []);

    // Attendance Type CRUD
    const openAddTypeModal = () => {
        setSelectedType(null);
        setFormTypeName('');
        setFormTypeDesc('');
        setFormTypeActive(1);
        setFormRequiresNotif(0);
        setFormNotifTime(0);
        setSelectedTeachers([]);
        fetchTeachers();
        setIsTypeModalOpen(true);
    };

    const openEditTypeModal = (type) => {
        setSelectedType(type);
        setFormTypeName(type.name);
        setFormTypeDesc(type.description || '');
        setFormTypeActive(type.is_active);
        setFormRequiresNotif(type.requires_notification || 0);
        setFormNotifTime(type.notification_time || 0);
        // Transform notify_teachers array into React-Select format

        fetchTeachers();
        const formattedSelected = (type.notify_teachers || []).map(t => ({
            label: t.teacher_name || t.full_name || "Unnamed Teacher",
            value: t.teacher_uuid || t.user_uuid || t.value
        }));
        setSelectedTeachers(formattedSelected);
        setIsTypeModalOpen(true);
    };

    const closeTypeModal = () => setIsTypeModalOpen(false);

    const handleSaveType = () => {
        if (!formTypeName) {
            toast.error("Name cannot be empty");
            return;
        }

        const headers = { 'token': localStorage.getItem('token') };

        const payload = {
            name: formTypeName,
            description: formTypeDesc,
            is_active: formTypeActive,
            requires_notification: formRequiresNotif,
            notification_time: formNotifTime,
            notify_teachers: selectedTeachers.map(t => t.value), // React-Select objects -> UUIDs
        };

        if (selectedType) {
            // Update existing type
            API.put(`/customAttendance/type/${selectedType.type_id}?is_portal=true`, payload, { headers })
                .then(res => {
                    if (res.data.response_code === 1000) {
                        toast.success("Type updated successfully");
                        closeTypeModal();
                        fetchAttendanceTypes();
                    } else {
                        toast.error(res.data.message);
                    }
                })
                .catch(() => toast.error("Error updating type"));
        } else {
            // Create new type
            API.post(`/customAttendance/type?is_portal=true`, payload, { headers })
                .then(res => {
                    if (res.data.response_code === 1000) {
                        toast.success("Type created successfully");
                        closeTypeModal();
                        fetchAttendanceTypes();
                    } else {
                        toast.error(res.data.message);
                    }
                })
                .catch(() => toast.error("Error creating type"));
        }
    };

    const openDeleteModal = (type) => {
        setSelectedDeleteType(type);
        setIsDeleteModalOpen(true);
    };

    const closeDeleteModal = () => setIsDeleteModalOpen(false);

    const handleDeleteType = () => {
        const headers = { 'token': localStorage.getItem('token') };
        API.delete(`/customAttendance/type/${selectedDeleteType.type_id}?is_portal=true`, { headers })
            .then(res => {
                if (res.data.response_code === 1000) {
                    toast.success("Type deleted");
                    closeDeleteModal();
                    fetchAttendanceTypes();
                } else toast.error(res.data.message);
            })
            .catch(() => toast.error("Error deleting type"));
    };

    return (
        <Fragment>
            <div className="container-fluid">
                <div className="card rounded-25">
                    <div className="card-header">
                        <h5>Custom Attendance Types</h5>
                        <button className="btn btn-primary float-end" onClick={openAddTypeModal}>Add Type</button>
                    </div>
                    <div className="card-body">
                        <DataTable
                            columns={columns}
                            data={attendanceTypes}
                            striped
                            persistTableHead
                            noDataComponent="No attendance types found. Click 'Add Type' to create one."
                        />
                    </div>
                </div>
            </div>

            {/* Add/Edit Type Modal */}
            <Modal isOpen={isTypeModalOpen} toggle={closeTypeModal}>
                <ModalHeader toggle={closeTypeModal}>
                    {selectedType ? "Edit Attendance Type" : "Add Attendance Type"}
                </ModalHeader>
                <ModalBody>
                    <div className="form-group">
                        <label>Name</label>
                        <input className="form-control" value={formTypeName} onChange={e => setFormTypeName(e.target.value)} />
                    </div>
                    <div className="form-group mt-2">
                        <label>Description</label>
                        <textarea className="form-control" rows="3" value={formTypeDesc} onChange={e => setFormTypeDesc(e.target.value)} />
                    </div>
                    <div className="form-group mt-2">
                        <label>Status</label>
                        <select className="form-control" value={formTypeActive} onChange={e => setFormTypeActive(Number(e.target.value))}>
                            <option value={1}>Active</option>
                            <option value={0}>Inactive</option>
                        </select>
                    </div>
                    <div className="form-group mt-3">
                        <label>Requires Notification</label>
                        <select className="form-control" value={formRequiresNotif} onChange={e => setFormRequiresNotif(Number(e.target.value))}>
                            <option value={1}>Yes</option>
                            <option value={0}>No</option>
                        </select>
                    </div>

                    {formRequiresNotif === 1 && (
                        <>
                            <div className="form-group mt-3">
                                <label>
                                    Notification Time (seconds)
                                    <span className="text-muted ms-1" style={{ fontSize: '0.9em' }}>
                                        — how long after check-in before alert is sent
                                    </span>
                                </label>

                                <input
                                    type="number"
                                    className="form-control"
                                    value={formNotifTime}
                                    min="0"
                                    onChange={e => setFormNotifTime(Number(e.target.value))}
                                    placeholder="e.g. 300 = 5 minutes"
                                />

                                {formNotifTime > 0 && (
                                    <small className="text-md text-black">
                                        ⏱ That’s approximately {(formNotifTime / 60).toFixed(1)} minutes after check-in.
                                    </small>
                                )}

                                {formNotifTime === 0 && (
                                    <small className="text-muted">
                                        If set to <strong>0</strong>, notifications are sent immediately after check-in.
                                    </small>
                                )}
                            </div><div className="form-group mt-3">
                                <label>Notify Teachers</label>
                                <Select
                                    isMulti
                                    options={teachers}
                                    value={selectedTeachers}
                                    onChange={(selected) => setSelectedTeachers(selected || [])}
                                    placeholder="Select teachers to notify..."
                                    classNamePrefix="react-select"
                                />
                                <small className="text-muted">
                                    Select one or more teachers who will receive notifications.
                                </small>
                            </div>


                        </>
                    )}

                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleSaveType}>{selectedType ? "Update" : "Add"}</Button>
                    <Button color="secondary" onClick={closeTypeModal}>Cancel</Button>
                </ModalFooter>
            </Modal>

            {/* Delete Modal */}
            <Modal isOpen={isDeleteModalOpen} toggle={closeDeleteModal}>
                <ModalHeader toggle={closeDeleteModal}>Confirm Delete</ModalHeader>
                <ModalBody>Delete type <strong>{selectedDeleteType?.name}</strong>?</ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={handleDeleteType}>Yes, Delete</Button>
                    <Button color="secondary" onClick={closeDeleteModal}>Cancel</Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
};

export default CustomAttendanceTypePage;
